<template>
    <img src="/images/promo/hero-section/iphone.png"
     alt="iphone" />
</template>

<script>
export default {};
</script>
